<template>
  <action-modal :is-open="true" @close="close">
    <span slot="title">{{ updateStatusInstructions }}</span>
    <v-layout> </v-layout>
    <v-layout wrap mt-4>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="selectedDate"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="selectedDate"
            prepend-icon="event"
            readonly
            v-on="on"
            outlined
          ></v-text-field>
        </template>
        <v-date-picker v-model="selectedDate" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="$refs.menu.save(selectedDate)"
            >OK</v-btn
          >
        </v-date-picker>
      </v-menu>
    </v-layout>
    <v-layout>
      <v-text-field
        v-model="notes"
        outlined
        textarea
        label="Notes"
        prepend-icon="notes"
      />
    </v-layout>
    <div slot="actions">
      <v-layout>
        <v-btn @click="save" color="primary">Save</v-btn>
      </v-layout>
    </div>
  </action-modal>
</template>

<script>
import ActionModal from "./ActionModal";
export default {
  name: "UpdateStatusModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    updateStatusInstructions: {
      type: String,
    },
  },
  data() {
    return {
      selectedDate: new Date().toISOString().substr(0, 10),
      menu: false,
      notes: null,
    };
  },
  components: {
    ActionModal,
  },
  computed: {
    open() {
      return this.isOpen;
    },
  },
  methods: {
    close() {
      this.$emit("update:updateStatusModal", false);
    },
    save() {
      const { selectedDate, notes } = this;
      const ctx = {
        selectedDate,
        notes,
      };
      this.$emit("updateStatusCtx", ctx);
      this.$emit("update:updateStatusModal", false);
    },
  },
};
</script>
